import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import InfoBox from 'components/Shared/InfoBox'
import Switch from 'components/Shared/Controls/Switch'
import {
  useCampaignMenu,
  useCampaignMenuDispatch,
} from 'components/Recommendations/Campaign/CampaignMenu/CampaignMenuContext'
import { actions } from 'components/Recommendations/Campaign/CampaignMenu/campaignStatusReducer'
import PortalModal from 'components/Shared/PortalModal'
import CampaignOptimizationModal from 'components/Recommendations/CampaignStatusModals/CampaignOptimizationModal'
import PlatformLabel from 'components/Shared/PlatformLabel'

export default function CampaignOptimisation({ event, disabled = false, bothSelected = false }) {
  const { t } = useTranslation()
  const { isCampaignOptimizationOn, isAdCampaignOptimizationOn } = useCampaignMenu()
  const statusDispatch = useCampaignMenuDispatch()

  const [isOptimizationModalOpen, setIsOptimizationModalOpen] = useState(false)
  const [isAdOptimizationModalOpen, setIsAdOptimizationModalOpen] = useState(false)

  return (
    <div
      className="campaign-optimisation field-wrapper"
    >
      <div className="platform-label-wrapper">
        <InfoBox content="Tips.Recommendations.campaignOptimisation">
          <span className="field-title">{t('Recommendations.summary.advancedSettings.campaignOptimisation.title')}</span>
        </InfoBox>
        
        <PlatformLabel platform={'meta'} bothSelected={bothSelected} />
      </div>

      <div className="d-flex flex-wrap" style={{ gap: '40px' }}>
        <div className="d-flex align-items-center gap-2">
          <p>{t('Recommendations.summary.advancedSettings.campaignOptimisation.forCampaign')}</p>

          <Switch
            classNames="p-0"
            checked={isCampaignOptimizationOn}
            disabled={disabled}
            onClick={() => {
              if (disabled) return
              setIsOptimizationModalOpen(true)
            }}
          />
        </div>

        <div className="d-flex align-items-center gap-2">
          <p>{t('Recommendations.summary.advancedSettings.campaignOptimisation.forAds')}</p>

          <Switch
            classNames="p-0"
            checked={isAdCampaignOptimizationOn}
            disabled={disabled}
            onClick={() => {
              if (disabled) return
              setIsAdOptimizationModalOpen(true)
            }}
          />
        </div>
      </div>

      <PortalModal
        isOpen={isOptimizationModalOpen}
        onClickOutside={() => setIsOptimizationModalOpen(false)}
      >
        <CampaignOptimizationModal
          status={isCampaignOptimizationOn ? 'deactivate' : 'activate'}
          translationKey="campaignOptimizationModal"
          onCancel={() => setIsOptimizationModalOpen(false)}
          onConfirm={() => {
            setIsOptimizationModalOpen(false)
            statusDispatch({ type: actions.toggleCampaignOptimizationAsync, payload: { event } })
          }}
        />
      </PortalModal>

      <PortalModal
        isOpen={isAdOptimizationModalOpen}
        onClickOutside={() => setIsAdOptimizationModalOpen(false)}
      >
        <CampaignOptimizationModal
          status={isAdCampaignOptimizationOn ? 'deactivate' : 'activate'}
          translationKey="adCampaignOptimizationModal"
          onCancel={() => setIsAdOptimizationModalOpen(false)}
          onConfirm={() => {
            setIsAdOptimizationModalOpen(false)
            statusDispatch({ type: actions.toggleAdCampaignOptimizationAsync, payload: { event } })
          }}
        />
      </PortalModal>
    </div>
  )
}

CampaignOptimisation.propTypes = {
  event: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  bothSelected: PropTypes.bool,
}
